import React, { useEffect, useState } from 'react';
import './thankyou.scss';
import { faSmile } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomButton from '../../components/commons/custom-button/custom-button.component';

function BreezeThankYouPage({
  title = 'Thank you for your submission!',
  subTitle = 'Please expect to receive a response from a Trinity staff member regarding your request within the next 24 hours.',
  instructionMessage = '',
}) {
  const history = useHistory();
  const [paramTitle, setParamTitle] = useState(null);
  const [paramSubTitle, setParamSubTitle] = useState(null);
  const [paramInstructionMessage, setParamInstructionMessage] = useState(null);

  useEffect(() => {
    const { location } = history;
    const { state } = location;
    if (location && state) {
      setParamTitle(state.title);
      setParamSubTitle(state.subTitle);
      setParamInstructionMessage(state.instructionMessage);
    }
  }, [history.location.state]);

  const onClickBackToLogin = () => {
    history.push('/');
  };

  return (
    <div className="thankyou-display">
      <div className="trinity-container">
        <div className="outer-container">
          <FontAwesomeIcon icon={faSmile} className="smile-icon" />
          <hr />
          <span className="outer-font">{paramTitle || title}</span>
          <h2
            className="light-font"
            dangerouslySetInnerHTML={{ __html: paramSubTitle || subTitle }}
          />
          <br />
          <span className="light-font">
            {paramInstructionMessage || instructionMessage}
          </span>
          <CustomButton
            title="Go Back To Home"
            onClick={onClickBackToLogin}
            style={{ marginTop: 20, marginBottom: 20 }}
          />
        </div>
      </div>
    </div>
  );
}

export default BreezeThankYouPage;
